// src/components/orders/ApplyVoucherWidget.jsx
import React, { useState } from "react";
import VouchersAPI from "../../api/v3/vouchers-api-v3";

function fmtIDR(n) {
  const v = Number(n) || 0;
  return "Rp " + v.toLocaleString("id-ID");
}

export default function ApplyVoucherWidget({
  orderId,
  onApplied,
  disabled,
  appliedCode,
  appliedDiscount, // << new
}) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    setMsg("");
    setErr("");
    try {
      const res = await VouchersAPI.apply(orderId, code.trim());
      setMsg(
        `Voucher applied: ${res.code} (discount ${fmtIDR(res.discount || 0)})`
      );
      setCode("");
      onApplied?.(res);
    } catch (e2) {
      const msg = e2?.data?.error || e2.message || "Failed to apply voucher";
      const d = e2?.data?.details;
      setErr(d ? `${msg}\n\nDetails:\n${JSON.stringify(d, null, 2)}` : msg);
    } finally {
      setBusy(false);
    }
  }

  const alreadyApplied = !!appliedCode || disabled;

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h5 className="mb-0">Voucher</h5>
          {alreadyApplied && (
            <span className="badge bg-success">
              Applied {appliedCode ? `(${appliedCode}` : ""}
              {appliedCode && typeof appliedDiscount === "number"
                ? ` — ${fmtIDR(appliedDiscount)}`
                : ""}
              {appliedCode ? ")" : ""}
            </span>
          )}
        </div>

        {msg && <div className="alert alert-success mt-2">{msg}</div>}
        {err && (
          <pre className="alert alert-danger mt-2 mb-0" style={{ whiteSpace: "pre-wrap" }}>
            {err}
          </pre>
        )}

        <form className="row g-2" onSubmit={onSubmit}>
          <div className="col">
            <input
              className="form-control"
              placeholder="Enter voucher code"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              disabled={busy || alreadyApplied}
            />
          </div>
          <div className="col-auto">
            <button className="btn btn-primary" type="submit" disabled={busy || alreadyApplied}>
              {busy ? "Applying..." : "Apply"}
            </button>
          </div>
        </form>

        {alreadyApplied && (
          <div className="form-text mt-2">
            One voucher per order. Remove voucher by editing order (server policy dependent).
          </div>
        )}
      </div>
    </div>
  );
}
